import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface PrayerTopic {
  id: string;
  date: string;
  category: string;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface PrayerImage {
  id: string;
  week_date: string;
  image_url: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}
